const Config = {
  baseUrl: 'https://preprod-secure1.mhelpdesk.com',
  apiUrl: 'https://preprod-secure1.mhelpdesk.com/api/api/',
  identity: {
    url: 'https://preprod-login.mhelpdesk.com',
    client_secret: 'test123',
    client_id: 'passwordless_ui',
  },
  googleMapKey: 'AIzaSyAsAabAn1M5xkm8SxZqES4XOulFIGjt9f8',
  launchDarklyClientId: '5d8cbad66d88da078e3345c1',
  mapQuestAPI: 'https://www.mapquestapi.com/search/v3/prediction',
  mapQuestAPIKey: 's5dBmTfK0OiSbGfEL8wU9IzPfNgaPNAR',
  qbUrl: 'https://preprod-qb.mhelpdesk.com/',
  qboUrl: 'https://preprod-quickbooks.mhelpdesk.com/Default.aspx',
  fuseBill: {
    publicKey: '6498cf27-4dc8-4bc6-b21a-ae3c46b8912e',
    transparentRedirectUrl:
      'https://payments.subscriptionplatform.com/api/paymentsv2/',
  },
  authScriptUrl: 'https://jstest.authorize.net/v3/AcceptUI.js',
  wePayServerMode: 'stage',
  wePayUrl: 'https://stage.wepay.com/login',
  pdfUrl: '/pdf',
  recurTestInverval: true,
  flagProvider: 'launchDarkly',
  showOldEstimateInvoiceLink: false,
  envName: 'preprod',
};

export default Config;



// WEBPACK FOOTER //
// ./src/config/config.PreProd.js